var generic = generic || {};
var site = site || {};

// resource bundling

site.drupalForm = {
  fbfInputNode : null,
  fbfContainerNode : null,
  fbfFormNode : null,
  fbfSubmitNode : null,
  fbfProgressNode : null,
  fbfSuccessNode : null,
  fbfErrorNode : null,
  initFbF : function() {
   fbfContainerNode = $("div.form-builder-container");
    if (!fbfContainerNode) {
      return null;
    }
    fbfFormNode = fbfContainerNode.find("form");
    fbfSubmitNode = fbfContainerNode.find("input[type='submit']");
    fbfProgressNode = fbfContainerNode.find("span.progress");
    fbfSuccessNode = fbfContainerNode.find("span.success");
    fbfErrorNode = fbfContainerNode.find("div.form-error");
    fbfInputNode = fbfContainerNode.find("input.email-signup");
    emailOptStatusNode = $("#address-info-newsletter");
    //fbfFormNode.bind("submit", function(submitEvt) {
    fbfFormNode.submit(function(submitEvt) {
      submitEvt.preventDefault();
      fbfProgressNode.removeClass("hidden");
      errorMsg = '';
      showErrors = false
      pass_required = false;
      // retrieve form data in querystring format
      var formSerial = $(this).serializeArray();
      $.each(formSerial, function(i, val) {
        val.value = $.trim(val.value).replace(/\r\n|\r|\n/g, '<br>').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
      });
      formSerial = $.param(formSerial).replace(/\+/g, ' ');
      // transform string into array of form elements
      var paramArr = formSerial.split("&"),
      paramStr = "";
      origStr = "";
      // iterate through collection to transform form name/value into key/value properties of a literal object string.
      $.each(paramArr, function(index){
        // strip form builder additionals
        initial = this.split('=')[0].replace('form%5B', '');
        initial = initial.replace('%5D', '');
        initial = decodeURI(initial);
        initial = initial.replace(/\[.*\]/, '');
        paramStr += '"'+ initial + '":"' + decodeURIComponent(this.split('=')[1]) + '",';
        origStr += '"'+ this.split('=')[0] + '":"' + this.split('=')[1] + '",';

      });
      // parse the string and create the literal object
      var params = eval("(" + "{"+paramStr.substring(0,(paramStr.length-1)).replace(/undefined/gi,"").replace(/%40/gi,"@")+"}" + ")");
      var origParams = eval("(" + "{"+origStr.substring(0,(origStr.length-1)).replace(/undefined/gi,"").replace(/%40/gi,"@")+"}" + ")");
      if (params['_SUBMIT'] == 'contact_us') {
        params['suppress_conf_email'] = 1;
      }

      //Unset the form action for unsubscribe form for ecomm site alone.
      if (params['_SUBMIT'] == 'email_unsubscribe_main' && typeof Drupal.settings.elc_form.is_ecom !== 'undefined')  {
        params['ACTION'] = 'unset';
      }

      var iframe_url =  Drupal.settings.basePath + 'elc_form_thankyou/' + Drupal.settings.elc_form.nid + '/' + Drupal.settings.elc_form.vid;

      // validation time
      var version = parseFloat($.fn.jquery);
      $(this).find("input, select, textarea").each(function() {
        if (version < 1.6){
          classes = jQuery(this).attr('class').split(' ');
        }
        else {
          classes = jQuery(this).prop('class').split(' ');
        }
        var is_checkbox = false;
        form_field = this;
        var field_value = jQuery(form_field).attr('value').replace(/^\s+|\s+$/g, '');
		
		//fix ie8 issue
		if(jQuery.browser.msie && jQuery.browser.version == "8.0"){
		  if('placeholder' in jQuery(form_field)[0]){
		    if(jQuery(form_field)[0]['placeholder'] == field_value) field_value = "";
		  }
		}
        jQuery(form_field).removeClass('label-error');
        jQuery.each(classes.reverse(), function(key, value) {
          switch (value) {
            case 'required':
              // checkbox check
              if (jQuery(form_field).attr('type') == 'checkbox') {
                is_checkbox = true;
              }
              var is_checked;
              if (version < 1.6){
                is_checked = jQuery(form_field).attr('checked');
              }
              else {
                is_checked = jQuery(form_field).prop('checked');
              }
              // check for checkbox type
              if (form_builder_required(field_value) == false || (is_checkbox == true && is_checked == false)) {
                showErrors = true;
                // fetch our validation message
                field = jQuery(form_field).attr('name').replace('form[', '');
                field = field.replace(']', '');
                if (is_checkbox == true) {
                  field = field.replace(/\[.*\]/, '');
                }
                if (typeof Drupal.settings.elc_form.validation_messages[field]['required'] != 'undefined') {
                  errorMsg += Drupal.settings.elc_form.validation_messages[field]['required'] + '<br>';
                }
                //set the error class for css
                pass_required = false;
                jQuery(form_field).prev().addClass('label-error');
                jQuery(form_field).parents('.resizable-textarea').prev().addClass('label-error');
              }
              else {
                jQuery(form_field).prev().removeClass('label-error');
                jQuery(form_field).parents('.resizable-textarea').prev().removeClass('label-error');
                pass_required = true;
              }
            break;
            case 'email_format':
              if (pass_required == true) {
                if (form_builder_email_format(field_value) == false) {
                  showErrors = true;
                  // fetch our validation message
                  field = jQuery(form_field).attr('name').replace('form[', '');
                  field = field.replace(']', '');
                  if (typeof Drupal.settings.elc_form.validation_messages[field]['email_format'] != 'undefined') {
                    errorMsg += Drupal.settings.elc_form.validation_messages[field]['email_format'] + '<br>';
                  }
                  //set the error class for css
                  jQuery(form_field).prev().addClass('label-error');
                }
              }
            break;
            case 'email_confirm':
              if (pass_required == true) {
                var related_field = jQuery('input[parent=' + jQuery(form_field).attr('related') + ']');
                if (form_builder_confirm_email(field_value, jQuery(related_field).attr('value').replace(/^\s+|\s+$/g, '')) == false) {
                  showErrors = true;
                  // fetch our validation message
                  field = jQuery(form_field).attr('name').replace('form[', '');
                  field = field.replace(']', '');
                  errorMsg += Drupal.settings.elc_form.validation_messages[field]['email_confirm'] + '<br>';
                  //set the error class for css
                  jQuery(form_field).prev().addClass('label-error');
                }
              }
            break;
            case 'number_check':
              if (pass_required == true) {
                if (form_builder_number_format(field_value) == false) {
                  showErrors = true;
                  // fetch our validation message
                  field = jQuery(form_field).attr('name').replace('form[', '');
                  field = field.replace(']', '');
                  errorMsg += Drupal.settings.elc_form.validation_messages[field]['required'] + '<br>';
                  //set the error class for css
                  jQuery(form_field).prev().addClass('label-error');
                }
              }
            break;
          }
        });

        /*if (jQuery(this).attr('class').indexOf('required') != -1) {
          if (form_builder_required(jQuery(this).attr('value')) == false) {
            showErrors = true;
            // fetch our validation message
            field = jQuery(this).attr('name').replace('form[', '');
            field = field.replace(']', '');
            errorMsg += Drupal.settings.elc_form.validation_messages[field]['required'] + '<br>';
            //set the error class for css
            jQuery(this).addClass('error');
          }
        }*/

      });
      // check for age check
      if (typeof Drupal.settings.elc_form.age_value != 'undefined') {
        if (form_builder_age_check(params, Drupal.settings.elc_form.age_value) == false) {
          showErrors = true;
          errorMsg += Drupal.settings.elc_form.validation_messages['AGE']['required'] + '<br>';
          jQuery('div.form-builder-container #edit-form-age-year, #edit-form-age-month, #edit-form-age-day').addClass('error');

        }
      }

      if (showErrors == true) {
        jQuery('.form-error').html(errorMsg);
        jQuery('.form-error').show();

      }
      else {
        jQuery('.form-error').hide();
        fbfSubmitNode.addClass("hidden");

        // Pass through form
        if (params._SUBMIT == 'pass-thru') {
          if (typeof Drupal.settings.elc_form.success_page != 'undefined') {
            var send_url = Drupal.settings.elc_form.success_page + "?";

            if (Drupal.settings.elc_form.use_iframe == true){
              send_url = iframe_url;
            }

            jQuery(".pass-thru").each(function() {
              send_url += jQuery(this).attr('name').replace('form[', '').replace(']', '') + "=" + jQuery(this).val();
            });

            window.location.href = send_url;
          }
        }
        var method = 'rpc.form';
        // CHeck to see if site is Ecom
        if (typeof Drupal.settings.elc_form.is_ecom !== 'undefined') {
          generic.jsonrpc.fetch({
            method : method,
            params: [params],
            onSuccess:function(jsonRpcResponse) {
              if (typeof Drupal.settings.elc_form.success != 'undefined') {
                fbfContainerNode.html(Drupal.settings.elc_form.success);
              }
              if (typeof Drupal.settings.elc_form.ajax != 'undefined') {
                // add our mapping params back in
                if (typeof Drupal.settings.elc_form != 'undefined') {
                  params['mapping'] = Drupal.settings.elc_form;
                }
                //now make call for emails
                jQuery.ajax({
                  type: 'POST',
                  url: '/elc_form_submit/' + Drupal.settings.elc_form.nid + '/' + Drupal.settings.elc_form.vid,
                  dataType: 'json',
                  data: params,
                  success: function(val) {
                    // crappy hack but we have to wait for emails to go out before redirecint
                    if (typeof Drupal.settings.elc_form.success_page != 'undefined') {
                      var send_url = Drupal.settings.elc_form.success_page + "?";

                      if (Drupal.settings.elc_form.use_iframe == true){
                        send_url = iframe_url;
                      }

                      jQuery(".pass-thru").each(function() {
                        send_url += jQuery(this).attr('name').replace('form[', '').replace(']', '') + "=" + jQuery(this).val();
                      });

                      window.location.href = send_url;
                    }

                  }
                });
              }

            },
            onFailure: function(jsonRpcResponse){
              var errorObjectsArray = jsonRpcResponse.getMessages();
              generic.showErrors(errorObjectsArray);
              jQuery('.form-error').show();
              fbfProgressNode.addClass("hidden");
              fbfSubmitNode.removeClass("hidden");
              fbfInputNode.addClass("error");
            }
          });
        }
        else {
          // We are on a coresite
          // See if we have a submit
          if (typeof params._SUBMIT != 'undefined') {
            var _SUBMIT = params._SUBMIT;
            // remove the pg_submit from the params
            delete params._SUBMIT;
          }
          // Only post if we have a submit
          if (typeof _SUBMIT != 'undefined') {
            var pg_reqs = Drupal.settings.perlgem.pg_reqs;
            var strLen = pg_reqs.length;
            pg_reqs = pg_reqs.slice(0,strLen-1);
            if (params.DOUBLE_OPTIN) {
              params.EMAIL_PROMOTIONS = "0";
            }
            if (_SUBMIT != 'contact+us' && _SUBMIT != 'contact_us') {
              jQuery.ajax({
                type: 'POST',
                url: '/' + _SUBMIT + '?' + pg_reqs,
                dataType: 'json',
                data: params,
                success: function(val) {
                  if(val.success == 0 && params.UNSUB_ERROR != 'undefined') {
                    fbfContainerNode.html(params.UNSUB_ERROR);
                    return false;
                  }
                  // crappy hack but we have to wait for emails to go out before redirecint
                  if (typeof Drupal.settings.elc_form.success != 'undefined') {
                    fbfContainerNode.html(Drupal.settings.elc_form.success);
                  }
                  if (typeof Drupal.settings.elc_form.ajax != 'undefined') {
                    // add our mapping params back in
                    if (typeof Drupal.settings.elc_form != 'undefined') {
                      params['mapping'] = Drupal.settings.elc_form;
                    }
                    //now make call for emails
                    jQuery.ajax({
                      type: 'POST',
                      url: '/elc_form_submit/' + Drupal.settings.elc_form.nid + '/' + Drupal.settings.elc_form.vid,
                      dataType: 'json',
                      data: params,
                      success: function(val) {
                        // crappy hack but we have to wait for emails to go out before redirecint
                        if (typeof Drupal.settings.elc_form.success_page != 'undefined') {
                          var send_url = Drupal.settings.elc_form.success_page + "?";

                          if (Drupal.settings.elc_form.use_iframe == true){
                            send_url = iframe_url;
                          }

                          jQuery(".pass-thru").each(function() {
                            send_url += jQuery(this).attr('name').replace('form[', '').replace(']', '') + "=" + jQuery(this).val();
                          });

                          window.location.href = send_url;
                        }

                      }
                    });
                  }
                  else {
                    if (typeof Drupal.settings.elc_form.success_page != 'undefined') {
                      var send_url = Drupal.settings.elc_form.success_page + "?";
                      if (Drupal.settings.elc_form.use_iframe == true){
                        send_url = iframe_url;
                      }
                      jQuery(".pass-thru").each(function() {
                        send_url += jQuery(this).attr('name').replace('form[', '').replace(']', '') + "=" + jQuery(this).val();
                      });
                      window.location.href = send_url;
                    }
                  }
                }
              });
            }
            else {
              if (typeof Drupal.settings.elc_form.success != 'undefined') {
                fbfContainerNode.html(Drupal.settings.elc_form.success);
              }

              if (typeof Drupal.settings.elc_form.success_page != 'undefined') {
                var send_url = Drupal.settings.elc_form.success_page + "?";

                if (Drupal.settings.elc_form.use_iframe == true){
                  send_url = Drupal.settings.basePath + 'elc_form_thankyou/' + Drupal.settings.elc_form.nid;
                }

                jQuery(".pass-thru").each(function() {
                  send_url = iframe_url;
                });

                window.location.href = send_url;
              }

              // add our mapping params back in
              if (typeof Drupal.settings.elc_form != 'undefined') {
                params['mapping'] = Drupal.settings.elc_form;
              }
              //now make call for emails
              jQuery.ajax({
                type: 'POST',
                url: '/elc_form_submit/' + Drupal.settings.elc_form.nid + '/' + Drupal.settings.elc_form.vid,
                dataType: 'json',
                data: params,
                success: function(val) {
                  // crappy hack but we have to wait for emails to go out before redirecint
                  if (typeof Drupal.settings.elc_form.success_page != 'undefined') {
                    var send_url = Drupal.settings.elc_form.success_page + "?";

                    if (Drupal.settings.elc_form.use_iframe == true){
                      send_url = iframe_url;
                    }

                    jQuery(".pass-thru").each(function() {
                      send_url += jQuery(this).attr('name').replace('form[', '').replace(']', '') + "=" + jQuery(this).val();
                    });

                    window.location.href = send_url;
                  }

                }
              });
            }
          }
        }
      }
    });
  }
};

(function ($, Drupal, site) {
  Drupal.behaviors.elc_form = {
    attach: function(context, settings) {
      site.drupalForm.initFbF();
    }
  }
})(jQuery, Drupal, site);
